import formErrorsHandler, {
    formErrorLoading
} from "api/global/form-errors-handler";
import {
    getApiInfo,
    getApiLogs,
    getApiLogItem,
    FETCH_API_INFO_SUCCESS,
    FETCH_API_LOGS_SUCCESS
} from "api/apiInfo";

export const fetchApiInfo = () => dispatch => {
    dispatch(formErrorLoading());
    getApiInfo()
        .then(response => {
            dispatch(formErrorLoading(false));
            dispatch({
                type: FETCH_API_INFO_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const fetchApiLogs = (reset = false) => dispatch => {
    if (reset) {
        dispatch({
            type: FETCH_API_LOGS_SUCCESS,
            payload: []
        });
        return;
    }
    dispatch(formErrorLoading());
    getApiLogs()
        .then(response => {
            dispatch(formErrorLoading(false));
            dispatch({
                type: FETCH_API_LOGS_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const fetchApiLogItem = (name, callback) => dispatch => {
    dispatch(formErrorLoading());
    getApiLogItem(name)
        .then(response => {
            dispatch(formErrorLoading(false));
            callback(response.data);
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};
